import { render, staticRenderFns } from "./OneCmsArticle.vue?vue&type=template&id=527a5436&"
import script from "./OneCmsArticle.vue?vue&type=script&lang=ts&"
export * from "./OneCmsArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports